// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/jobs/:job_id/errors" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { integrationsDirectCdiJobsJobIdErrors } from "./constants";
import type { IntegrationsDirectCdiJobsJobIdErrorsParams, CdiJobErrorsResult } from "./types";

export const getCdiJobErrors = reactQueryTableFetcherAdapter(
  integrationsDirectCdiJobsJobIdErrors,
  (
    signal: AbortSignal,
    {
      jobId,
      appGroupId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: IntegrationsDirectCdiJobsJobIdErrorsParams
  ): Promise<CdiJobErrorsResult> => {
    return fetch(
      `/integrations/direct/cdi/jobs/${jobId}/errors`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
